<template>
  <!-- same layout/style as the "Diabetic Eye Exam CPT Category II" section in ReportHedis -->
  <div class="report-status-selection" :class="{'unified-report': isUnifiedReport, 'invalid': invalid}">
    <div class="section-box">
      <h4>{{ $t('report.reportStatus') }} <span class="required">*</span></h4>

      <div class="cpt-container" v-if="!isUnifiedReport">
        <div v-for="status in options" :key="status" class="cpt-item">
          <div class="checkbox-item">
            <input
              type="radio" :id="`reportStatus_${status}`"
              :value="status"
              :checked="modelValue === status"
              name="reportStatus"
              required
              @change="$emit('update:modelValue', status)"
              :data-test="`radioReportStatus_${status}`">
            <label :for="`reportStatus_${status}`">{{ $t(`report.reportStatus_${status}`) }}</label>
          </div>
        </div>
      </div>

      <div class="cpt-container" v-else>
        <div v-for="status in options" :key="status" class="cpt-item">
          <div class="checkbox-item">
            <BaseRadioButton
              :id="`reportStatus_${status}`"
              :item="status"
              :checked="modelValue === status"
              @checked="$emit('update:modelValue', $event)"
              :data-test="`radioReportStatus_${status}`"/>
            <label @click="$emit('update:modelValue', status)">{{ $t(`report.reportStatus_${status}`) }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.report-status-selection {
  width:                         100%;

  // space above the save/update footer; set on the inner box because report.scss
  // (form > div > div) already sets padding on this root element and wins on specificity
  .section-box {
    padding-bottom:              1.5rem;
  }

  h4 {
    color:                       var(--Shades-90);
    font-size:                   var(--font-size-14);
    font-weight:                 bold;

    .required {
      color:                     #D9534F;
    }
  }

  .cpt-container {
    display:                     flex;
    flex-wrap:                   wrap;
    gap:                         1.5rem;
  }

  .cpt-item {
    display:                     flex;
    flex-direction:              column;
    flex:                        1 1 calc(33% - 1rem);
  }

  .checkbox-item {
    display:                     flex;
    align-items:                 center;

    input[type="radio"] {
      margin-right:              0.5rem;
    }

    label {
      color:                     var(--Shades-80);
      font-size:                 var(--font-size-14);
      font-weight:               normal;
      cursor:                    pointer;
    }
  }

  &.unified-report {
    .checkbox-item label {
      color:                     var(--Brand-Primary);
      font-size:                 var(--font-size-12);
    }
  }

  &.invalid {
    .checkbox-item label {
      color:                     #D9534F;
    }

    input[type="radio"] {
      outline:                   1px solid #D9534F;
    }

    :deep(.base-rounded-radiobutton) {
      border-color:              #D9534F;
    }
  }
}

@media (max-width: 991px) {
  .report-status-selection {
    .cpt-container {
      flex-wrap:                 wrap;

      .cpt-item {
        flex:                    unset;
      }
    }
  }
}
</style>

<script>
export default {
  name: 'ReportStatusSelection',
  props: {
    modelValue: {type: String, required: false},
    options: {type: Array, required: true},
    isUnifiedReport: {type: Boolean, default: false},
    invalid: {type: Boolean, default: false}
  },
  emits: ['update:modelValue']
}
</script>
